export default "__VITE_ASSET__BEtr_Z_X__"